import React, {Component, Fragment} from 'react';
import './index.scss';


//assets
import Arrow     from 'assets/icons/slider-arrow-white.svg';
import ArrowUp     from 'assets/icons/arrow-up-white-fill.svg';
import {connect} from "react-redux";
import {sendBenefitCoupon} from "../../../redux/actions";
import {getMediaPath} from "../../../app/functions";


let prev = 0;


class ScrollUp extends Component {

    constructor(props){
        super(props);

        this.state = {
            scrollUp: false,
            enableShow: true,
        }
    }

    componentDidMount(){
        window.addEventListener('scroll',this.handleScroll);
    }


    handleScroll = (e) => {
        const scrollUp = this.state.scrollUp;
        const enableShow = this.state.enableShow;
        const window = e.currentTarget;

        const newState = {};

        if (prev > window.scrollY) {
            if (!scrollUp && enableShow) {
                newState.scrollUp = true;
            }
        } else {
            if (scrollUp) {
                newState.scrollUp = false;
            }
        }

        // Disable option if the user is on top of the page already
        if (window.scrollY < 10) {
            newState.enableShow = false;
        } else {
            newState.enableShow = true;
        }

        this.setState(newState);

        prev = window.scrollY;
    };

     handleScrollTo = () => {

         //remove scroll listener so we can hide the button
         this.setState({enableShow: false});
         //reset button appearance condition

         this.setState({scrollUp: false});

         //scroll to top
         let header_element = document.getElementsByClassName('App');
         header_element[0].scrollIntoView();
         //re-attach listener at later time
         setTimeout(() => {
             this.setState({enableShow: true});
         }, 2000);
     };

     render() {
         const isDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';
         return (
             <Fragment>
                 {isDesktop &&
                 <div className={"scroll-up" + ((this.state.scrollUp && this.state.enableShow) ? ' active' : '')}
                      onClick={this.handleScrollTo}>
                     <img className="arrow" src={getMediaPath(ArrowUp)} alt=""/>
                 </div>
                 }
             </Fragment>
         )
     }
};

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
    }
}

const mapDispatchToProps = dispatch =>{
    return{}
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(ScrollUp);
